import { useQuery } from "@tanstack/react-query";

/**
 * A partner-portal read.
 *
 * The app's QueryClient sets `refetchOnMount: false` globally, so a cross-component
 * `invalidateQueries` never refreshes a query that was inactive at the time — a page reopened after
 * an admin approved a commission or filed a document would show the state from the last visit.
 * Every portal read goes through here so mounting a page is always a refetch; pass
 * `refetchOnMount: false` explicitly in the rare case where that is wrong.
 */
const usePartnerQuery = (key, fetcher, options = {}) =>
  useQuery(key, fetcher, { refetchOnMount: true, ...options });

export default usePartnerQuery;
